module.exports = __webpack_public_path__ + "static/media/salad-vegetable.b50db8ca.png";